import { useRef, useEffect, useState } from "react";
import { useMotionValue } from "framer-motion";
import { motion } from "framer-motion";

export default function HorizontalScrollSlider(props) {

    const { slides } = props;

    const containerRef = useRef(null);
    const x = useMotionValue(0);
    const [vw, setVw] = useState(0);
    const [isMobileView, setIsMobileView] = useState(false);


    useEffect(() => {
        setVw(window.innerWidth);
        setIsMobileView(window.innerWidth <= 1380);

        const handleResize = () => {
            setVw(window.innerWidth);
            setIsMobileView(window.innerWidth <= 1380);
        };
        window.addEventListener("resize", handleResize);

        if (window.innerWidth <= 1380) {
            return () => {
                window.removeEventListener("resize", handleResize);
            };
        }

        const handleScroll = () => {
            if (!containerRef.current) return;

            const rect = containerRef.current.getBoundingClientRect();
            const sectionHeight = rect.height;
            const windowHeight = window.innerHeight;

            const progress = Math.min(Math.max((windowHeight - rect.top) / (windowHeight + sectionHeight), 0), 1);

            const slideWidth = vw * 0.55; // 50% Viewport
            const gap = vw * 0.05; // 5% Abstand

            // maximale Verschiebung = (Summe aller Slides + gaps) - sichtbare Breite
            const totalWidth = slides.length * (slideWidth + gap) - gap;
            x.set(-progress * (totalWidth - vw)); // minus vw, damit erste Slide sichtbar bleibt

        };

        window.addEventListener("scroll", handleScroll);
        handleScroll();

        return () => {
            window.removeEventListener("scroll", handleScroll);
            window.removeEventListener("resize", handleResize);
        };
    }, [vw, slides.length, x]);

    if (vw === 0) return null;

    if (isMobileView) {
        return (
            <section
                style={{
                    width: "100%",
                    overflowX: "auto",
                    overflowY: "hidden",
                    display: "flex",
                    gap: "20px",
                    padding: "8px 0 14px",
                    scrollSnapType: "x mandatory",
                    WebkitOverflowScrolling: "touch",
                    alignItems: "stretch",
                    WebkitMaskImage: "linear-gradient(to right, transparent 0px, black 8px, black calc(100% - 8px), transparent 100%)",
                    maskImage: "linear-gradient(to right, transparent 0px, black 8px, black calc(100% - 8px), transparent 100%)",
                }}
            >
                {slides.map((slide, i) => (
                    <div
                        key={i}
                        style={{
                            minWidth: "72vw",
                            width: "72vw",
                            scrollSnapAlign: "start",
                            flexShrink: 0,
                            display: "flex",
                        }}
                    >
                        <div
                            style={{
                                width: "100%",
                                height: "100%",
                                minHeight: slide.description !== "" ? "320px" : "auto",
                                background: slide.bg,
                                borderRadius: "16px",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "flex-start",
                                padding: "16px",
                                boxShadow: "0 4px 15px rgba(0,0,0,0.3)",
                                boxSizing: "border-box",
                            }}
                        >
                            <img
                                src={slide.img}
                                alt={`Slide ${i + 1}`}
                                style={{ maxWidth: "100%", maxHeight: slide.caption !== "" ? "170px" : "100%", objectFit: "contain", borderRadius: "10px" }}
                            />
                            {slide.caption !== "" && (
                                <>
                                    <b style={{ color: "var(--ci_color_secondary)", marginTop: "12px", fontSize: "20px", fontWeight: 800, textAlign: "center" }}>
                                        {slide.caption}
                                    </b>
                                    <p style={{ marginTop: "12px", fontSize: "16px", fontWeight: 500, padding: "0 4px", textAlign: "center", width: "100%" }}>
                                        {slide.description}
                                    </p>
                                </>
                            )}
                        </div>
                    </div>
                ))}
            </section>
        );
    }

    return (
        <section
            ref={containerRef}
            style={{
                position: "relative",
                height: "42vh",
                // overflow: "hidden",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                paddingLeft: "25vw",
                marginTop: "80px",

            }}
        >
            <motion.div style={{ display: "flex", x }}>
                {slides.map((slide, i) => (
                    <div
                        key={i}
                        style={{
                            width: "30vw",
                            marginRight: i === slides.length - 1 ? 0 : "5vw",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <div
                            style={{
                                width: "100%",
                                height: slide.caption != "" ? "42vh" : "auto",
                                background: slide.bg,
                                borderRadius: "20px",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                padding: "30px",
                                boxShadow: "0 4px 15px rgba(0,0,0,0.3)",
                            }}
                        >
                            <img
                                src={slide.img}
                                alt={`Slide ${i + 1}`}
                                style={{ maxWidth: slide.caption != "" ? "auto" : "100%", maxHeight: slide.caption != "" ? "60%" : "fit-content", objectFit: "contain", borderRadius: "12px" }}
                            />
                            {slide.caption != "" && (<>
                                <b style={{ color: "var(--ci_color_secondary)", marginTop: "15px", fontSize: "26px", fontWeight: 800 }}>
                                    {slide.caption}
                                </b>
                                <p style={{ marginTop: "20px", fontSize: "20px", fontWeight: 500, padding: "10px", paddingBottom: "20px" }}>
                                    {slide.description}
                                </p>
                            </>
                            )}
                        </div>
                    </div>
                ))}
            </motion.div>
        </section>
    );
}